import { USER } from '@/models/auth/permissions.enum';
import { constants } from '@/config';
import AnalyticsYourPostsPage from '@/components/core/analytics/AnalyticsYourPostsPage.vue';

const App = () => import('@/app/pinterest/App.vue');
const BoardsIndex = () => import('@/app/boards/pages/BoardsIndex.vue');
const Overview = () => import('@/app/pinterest/pages/Overview.vue');
const Followers = () => import('@/app/pinterest/pages/Followers.vue');
const Engagement = () => import('@/app/pinterest/pages/Engagement.vue');

const PAGE_LEVEL_TOP = `Pinterest`;
const PAGE_LEVEL_INSIGHTS = `Insights`;
const PAGE_LEVEL_DH_BOARDS = `DH Boards`;

export default {
  path: 'pinterest',
  component: App,
  meta: {
    requiresAuth: true,
    permissions: [USER.PINTEREST.CAN_ACCESS_PINT],
  },
  children: [
    {
      name: 'pinterest',
      path: '',
      meta: {
        analytics: `${PAGE_LEVEL_TOP}`,
      },
      redirect: { name: 'pinterest.index.overview' },
    },
    {
      name: 'pinterest.index',
      path: 'dashboard',
      component: Overview,
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Overview`,
        pinterestRoute: true,
      },
      redirect: { name: 'pinterest.index.overview' },
    },
    {
      name: 'pinterest.index.overview',
      path: 'overview',
      component: Overview,
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Overview`,
        pinterestRoute: true,
      },
    },
    {
      name: 'pinterest.insights.engagement',
      path: 'engagement',
      component: Engagement,
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - ${PAGE_LEVEL_INSIGHTS} - Your Engagement`,
        pinterestRoute: true,
      },
    },
    {
      name: 'pinterest.insights.engagement.report',
      path: 'engagement/report',
      component: Engagement,
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - ${PAGE_LEVEL_INSIGHTS} - Your Engagement Report`,
        report: true,
      },
    },
    {
      name: 'pinterest.insights.followers',
      path: 'followers',
      component: Followers,
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - ${PAGE_LEVEL_INSIGHTS} - Your Followers`,
        pinterestRoute: true,
      },
    },
    {
      name: 'pinterest.insights.followers.report',
      path: 'followers/report',
      component: Followers,
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - ${PAGE_LEVEL_INSIGHTS} - Your Followers Report`,
        report: true,
        layout: 'horizontal',
      },
    },
    {
      name: 'pinterest.insights.pins',
      path: 'pins',
      component: AnalyticsYourPostsPage,
      props: {
        channel: constants.PINTEREST,
      },
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - ${PAGE_LEVEL_INSIGHTS} - Your Pins`,
        pinterestRoute: true,
      },
    },
    {
      name: 'pinterest.insights.pins.report',
      path: 'pins/report',
      component: AnalyticsYourPostsPage,
      props: {
        channel: constants.PINTEREST,
      },
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - ${PAGE_LEVEL_INSIGHTS} - Your Pins Report`,
        report: true,
      },
    },
    {
      path: 'board',
      children: [
        {
          name: 'pinterest.galleries',
          path: '',
          component: BoardsIndex,
          props: {
            galleryType: constants.PINTEREST,
          },
          meta: {
            analytics: `${PAGE_LEVEL_TOP} - ${PAGE_LEVEL_DH_BOARDS}`,
            pinterestRoute: true,
            permissions: [USER.PINTEREST.CAN_ACCESS_PINT_BOARDS],
          },
        },
      ],
    },
  ],
};
